<div class="header">
  <h3>Admin</h3>
</div>
<div class="row">
  <div class="col tab-menu">
    <admin-nav-menu [currentTab]="'questions'"></admin-nav-menu>
  </div>

  <div class="col form-wrapper form-wrapper-constrained">
    <h4>{{question.id > 0 ? 'Edit Question' : 'New Question'}}</h4>
    <form #questionForm="ngForm" (ngSubmit)="saveChanges()">
      <fieldset [disabled]="isLoading || isSaving">
        <div class="d-flex align-items-center mt-2 mb-3">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            [disabled]="questionForm.invalid || questionCodeDuplicate || isCheckingCode || !optionsValid">
            <i class="fa fa-save"></i>
            Save
          </button>
          <button type="button" class="btn btn-secondary mr-2" (click)="goHome()">
            <i class="fa fa-times"></i>
            Cancel
          </button>
          <small class="form-text text-muted d-inline-flex">Please note: <b class="required px-2">*</b> indicates a required field</small>
          @if (question.id > 0) {
            <button type="button" class="btn btn-info ms-auto" (click)="openActivityLog()">
              <i class="fa fa-history"></i>
              Activity Log
            </button>
          }
        </div>
        <hr />

        <div class="form-group row">
          <label for="inspection-question-code" class="form-label col-sm-2 required">Question Code</label>
          <div class="col">
            <input
              type="text"
              id="inspection-question-code"
              name="questionCode"
              class="form-control"
              [(ngModel)]="question.questionCode"
              (ngModelChange)="onQuestionCodeChanged()"
              (blur)="checkQuestionCode()"
              maxlength="50"
              pattern=".*\S.*"
              required />
            <small class="form-text validation-message">Question Code is required, cannot be blank, and cannot exceed 50 characters.</small>
            @if (questionCodeDuplicate) {
              <small class="form-text text-danger">A question with this Question Code already exists.</small>
            }
          </div>
        </div>

        <div class="form-group row">
          <label for="inspection-question-text" class="form-label col-sm-2 required">Question</label>
          <div class="col">
            <textarea
              id="inspection-question-text"
              name="questionText"
              class="form-control text-editor text-editor-md"
              [(ngModel)]="question.questionText"
              pattern="[\s\S]*\S[\s\S]*"
              required></textarea>
            <small class="form-text validation-message">Question text is required and cannot be blank.</small>
          </div>
        </div>

        <div class="form-group row">
          <label for="inspection-question-help-text" class="form-label col-sm-2">Help Text</label>
          <div class="col">
            <textarea
              id="inspection-question-help-text"
              name="helpText"
              class="form-control text-editor text-editor-md"
              [(ngModel)]="question.helpText"></textarea>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-6 mb-3">
            <label for="inspection-question-topics" class="form-label required">Topics</label>
            <ng-select
              #topicsControl="ngModel"
              id="inspection-question-topics"
              name="topicIds"
              placeholder="Select one or more..."
              [multiple]="true"
              [searchable]="true"
              [closeOnSelect]="false"
              [(ngModel)]="question.topicIds"
              (change)="onTopicsChanged()"
              required>
              @for (topic of sortedTopics; track topic.id) {
                <ng-option [value]="topic.id" [disabled]="isTopicDisabled(topic)">
                  {{topic.name}}{{topic.isActive ? '' : ' (Inactive)'}}
                </ng-option>
              }
            </ng-select>
            @if (topicsControl.invalid && topicsControl.touched) {
              <small class="form-text text-danger">At least one Topic is required.</small>
            }
          </div>

          <div class="col-md-6 mb-3">
            <label for="inspection-question-standard" class="form-label">Standard</label>
            <ng-select
              id="inspection-question-standard"
              name="standardId"
              placeholder="Select one..."
              [searchable]="true"
              [clearable]="true"
              [(ngModel)]="question.standardId"
              (change)="onStandardChanged()">
              @for (standard of sortedStandards; track standard.id) {
                <ng-option [value]="standard.id" [disabled]="isStandardDisabled(standard)">
                  {{standard.name}}{{standard.isActive ? '' : ' (Inactive)'}}
                </ng-option>
              }
            </ng-select>
          </div>
        </div>

        <div class="form-group row">
          <label for="inspection-question-type" class="form-label col-sm-2 required">Question Type</label>
          <div class="col">
            <select
              id="inspection-question-type"
              name="questionType"
              class="form-control"
              [(ngModel)]="question.questionType"
              (ngModelChange)="onQuestionTypeChanged($event)"
              required>
              @for (questionType of questionTypes; track questionType.value) {
                <option [ngValue]="questionType.value">{{questionType.label}}</option>
              }
            </select>
          </div>
        </div>

        @if (showAnswerOptions) {
          <div class="mt-4">
            <div class="row mb-2">
              <div class="col-sm-5"><strong>Answer Options<span class="text-danger">*</span></strong></div>
              <div class="col-sm-5"><strong>Branching Question</strong></div>
              <div class="col-sm-2"></div>
            </div>

            @for (option of question.options; track option; let optionIndex = $index) {
              <div class="row mb-3 align-items-start">
                <div class="col-sm-5">
                  <input
                    #optionTextControl="ngModel"
                    type="text"
                    class="form-control"
                    [id]="'inspection-question-option-' + optionIndex"
                    [name]="'optionText-' + optionIndex"
                    [(ngModel)]="option.optionText"
                    maxlength="500"
                    pattern=".*\S.*"
                    required />
                  @if (optionTextControl.invalid && optionTextControl.touched) {
                    <small class="form-text text-danger">Option text is required, cannot be blank, and cannot exceed 500 characters.</small>
                  }
                  @if (isDuplicateOption(optionIndex)) {
                    <small class="form-text text-danger">Answer option text must be unique.</small>
                  }
                </div>
                <div class="col-sm-5">
                  <ng-select
                    [id]="'inspection-question-branch-' + optionIndex"
                    [name]="'branchingQuestionId-' + optionIndex"
                    placeholder="Select one..."
                    [searchable]="true"
                    [clearable]="true"
                    [(ngModel)]="option.branchingQuestionId"
                    (change)="onBranchingQuestionChanged(option)">
                    @for (branchingQuestion of sortedBranchingQuestions; track branchingQuestion.id) {
                      <ng-option
                        [value]="branchingQuestion.id"
                        [disabled]="isBranchingQuestionDisabled(branchingQuestion, option)">
                        {{branchingQuestion.questionCode}} - {{branchingQuestion.questionText}}{{isBranchingQuestionInactive(branchingQuestion) ? ' (Inactive)' : ''}}
                      </ng-option>
                    }
                  </ng-select>
                </div>
                <div class="col-sm-2">
                  <button
                    type="button"
                    class="btn btn-link text-danger p-0"
                    title="Delete answer option"
                    (click)="deleteAnswerOption(optionIndex)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </div>
            }

            @if (question.options.length < 2) {
              <small class="form-text text-danger mb-2">At least two answer options are required.</small>
            }
            <button type="button" class="btn btn-link text-danger p-0" (click)="addAnswerOption()">
              <i class="fa fa-plus"></i>
              Add Answer Option
            </button>
          </div>
        }
      </fieldset>
    </form>
  </div>
</div>

<ng-template #activityLogModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="inspection-question-activity-log-title">Question Activity Log</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @if (isLoadingActivityLog) {
      <span class="d-block p-2 text-center">
        <i class="fa fa-spinner fa-spin"></i>
        Loading activity log&hellip;
      </span>
    } @else if (activityLogLoadError) {
      <span class="d-block p-2 text-center text-danger">
        <i class="fa fa-exclamation-triangle"></i>
        The activity log could not be loaded.
      </span>
    } @else {
      <div class="d-flex align-items-center mb-2">
        <div ngbDropdown autoClose="outside" class="d-inline-block mr-2"
          [placement]="['bottom-left', 'bottom-right', 'top-left', 'top-right']"
          (openChange)="onActivityLogFilterOpen($event)" #activityFilterDropdown="ngbDropdown">
          <button type="button" class="btn btn-sm btn-secondary" id="question-activity-filter-toggle" ngbDropdownToggle>
            <i class="fa fa-filter"></i>
            Filter
          </button>
          <div ngbDropdownMenu aria-labelledby="question-activity-filter-toggle" class="p-3" style="min-width: 22rem;">
            <div class="mb-2">
              <label for="question-activity-user-filter" class="form-label mb-1">User</label>
              <div class="d-flex">
                <input id="question-activity-user-filter" type="text" class="form-control form-control-sm"
                  [(ngModel)]="draftActivityLogFilters.user" />
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear User" [disabled]="!draftActivityLogFilters.user"
                  (click)="clearActivityLogFilter('user')">&times;</button>
              </div>
            </div>
            <div class="mb-2">
              <label for="question-activity-field-filter" class="form-label mb-1">Field Changed</label>
              <div class="d-flex">
                <select id="question-activity-field-filter" class="form-control form-control-sm"
                  [(ngModel)]="draftActivityLogFilters.fieldName">
                  <option [ngValue]="null">All fields</option>
                  @for (field of activityLogFieldOptions; track field.value) {
                    <option [ngValue]="field.value">{{field.label}}</option>
                  }
                </select>
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear Field Changed" [disabled]="!draftActivityLogFilters.fieldName"
                  (click)="clearActivityLogFilter('fieldName')">&times;</button>
              </div>
            </div>
            <div class="mb-2">
              <label for="question-activity-old-value-filter" class="form-label mb-1">Old Value</label>
              <div class="d-flex">
                <input id="question-activity-old-value-filter" type="text" class="form-control form-control-sm"
                  [(ngModel)]="draftActivityLogFilters.oldValue" />
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear Old Value" [disabled]="!draftActivityLogFilters.oldValue"
                  (click)="clearActivityLogFilter('oldValue')">&times;</button>
              </div>
            </div>
            <div class="mb-2">
              <label for="question-activity-new-value-filter" class="form-label mb-1">New Value</label>
              <div class="d-flex">
                <input id="question-activity-new-value-filter" type="text" class="form-control form-control-sm"
                  [(ngModel)]="draftActivityLogFilters.newValue" />
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear New Value" [disabled]="!draftActivityLogFilters.newValue"
                  (click)="clearActivityLogFilter('newValue')">&times;</button>
              </div>
            </div>
            <div class="mb-2">
              <label for="question-activity-from-filter" class="form-label mb-1">Changed From (UTC)</label>
              <div class="d-flex">
                <input id="question-activity-from-filter" type="datetime-local" step="1"
                  class="form-control form-control-sm" [(ngModel)]="draftActivityLogFilters.changedFromUtc" />
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear Changed From" [disabled]="!draftActivityLogFilters.changedFromUtc"
                  (click)="clearActivityLogFilter('changedFromUtc')">&times;</button>
              </div>
            </div>
            <div class="mb-2">
              <label for="question-activity-to-filter" class="form-label mb-1">Changed To (UTC)</label>
              <div class="d-flex">
                <input id="question-activity-to-filter" type="datetime-local" step="1"
                  class="form-control form-control-sm" [(ngModel)]="draftActivityLogFilters.changedToUtc" />
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear Changed To" [disabled]="!draftActivityLogFilters.changedToUtc"
                  (click)="clearActivityLogFilter('changedToUtc')">&times;</button>
              </div>
            </div>
            @if (activityLogDateFilterError) {
              <div class="text-danger small mb-2">{{activityLogDateFilterError}}</div>
            }
            <button type="button" class="btn btn-sm btn-primary"
              (click)="applyActivityLogFilters(activityFilterDropdown)">Apply</button>
          </div>
        </div>
        <button type="button" class="btn btn-sm btn-secondary"
          [disabled]="!hasActivityLogFilters"
          (click)="clearActivityLogFilters(activityFilterDropdown)">
          <i class="fa fa-times"></i>
          Clear All
        </button>
      </div>

      @if (activityLog.length === 0) {
        <span class="d-block p-2 text-center">
          <i class="fa fa-ban text-danger"></i>
          {{hasActivityLogFilters ? 'No activity matches the current filters.' : 'No activity to display.'}}
        </span>
      } @else {
        <div class="table-responsive">
          <table class="table table-sm table-align-middle">
            <thead>
              <tr class="headers-row">
                <th>User</th>
                <th>Field Changed</th>
                <th>Old Value</th>
                <th>New Value</th>
                <th>Date/Time (UTC)</th>
              </tr>
            </thead>
            <tbody>
              @for (change of activityLog; track change) {
                <tr>
                  <td>{{getActivityLogUser(change)}}</td>
                  <td>{{getActivityLogFieldName(change)}}</td>
                  <td class="text-break">{{getActivityLogValue(change.oldValue, change.fieldName)}}</td>
                  <td class="text-break">{{getActivityLogValue(change.newValue, change.fieldName)}}</td>
                  <td class="text-nowrap">{{formatActivityLogDate(change.changedAtUtc)}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('close')">Close</button>
  </div>
</ng-template>
